import styled from 'styled-components';
import { Box } from '@mui/material';
import { NewDialog } from 'web-components';

const StyledNewDialog = styled(NewDialog)`
  .MuiDialog-paper {
    border-radius: 0.625rem;
    width: 80%;
    max-height: 90%;

    form {
      width: 100%;
    }
  }

  h2:first-of-type {
    padding-bottom: unset;
  }
`;

const StyledHandlers = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export { StyledNewDialog, StyledHandlers };
